import React from 'react';
import SocialLinksBar from '../../buttons/SocialLinksBar/SocialLinksBar';

import BookNowBar from '../../buttons/BookNowBar/BookNowBar';
import mainBanner from '../../../../images/main/Desktop Hero 1.webp';

import './HomeHeroBanner.css';

const HomeHeroBanner = () => {
  return (
    <div className='homePage-banner'>
      <img src={mainBanner} alt='banner' className='banner-img' />
      <div className='home-banner-content-container'>
        <div className='content-top-left-container'>
          <BookNowBar />
        </div>
        <div className='content-bottom-center-container'>
          <SocialLinksBar />
        </div>
      </div>
    </div>
  );
};

export default HomeHeroBanner;
